import { useRef, useCallback } from 'react'
import { GridApi } from 'ag-grid-community'

export function useGridContext(
  gridApi: GridApi | undefined,
  initialContext: Record<string, any>
) {
  const contextRef = useRef<Record<string, any>>(initialContext)

  const updateContext = useCallback(
    (partial: Record<string, any>) => {
      contextRef.current = { ...contextRef.current, ...partial }
      gridApi?.setGridOption('context', contextRef.current)
    },
    [gridApi]
  )

  return { contextRef, updateContext }
}
